require('../../modules/es7.string.trim-left');
module.exports = require('../../modules/_core').String.trimLeft;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/trim-start.js
// module id = 3064
// module chunks = 25